// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Grid,
//   Card,
//   CardMedia,
//   Container,
//   CardContent,
//   Typography,
//   Box,
//   Select,
//   MenuItem,
//   ButtonBase,
//   CircularProgress,
//   TextField,
//   Button,
//   ToggleButtonGroup,
//   ToggleButton,
//   useMediaQuery,
//   useTheme
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import creditCards from "../JSON/creditCardData.json";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import "aos/dist/aos.css";
// import Aos from "aos";

// const BankingProductsScreen = () => {
//   const navigate = useNavigate();


//   const theme = useTheme();
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
//   useEffect(() => {
//     Aos.init({ duration: 1000, once: false });
//   }, []);

//   // ------------------------
//   // Filtering & Toggle States
//   // ------------------------
//   const [filter, setFilter] = useState("recommended");
//   const [bankFilter, setBankFilter] = useState("");

//   const handleFilterChange = (event, newFilter) => {
//     if (newFilter !== null) setFilter(newFilter);
//   };

//   const handleBankFilterChange = (event) => {
//     setBankFilter(event.target.value);
//   };

//   // ------------------------
//   // Pincode Check States
//   // ------------------------
//   const [pincode, setPincode] = useState("");
//   const [pincodeResult, setPincodeResult] = useState(null);
//   const [pincodeLoading, setPincodeLoading] = useState(false);
//   const [pincodeError, setPincodeError] = useState(null);

//   // ------------------------
//   // Infinite Scroll for JSON Cards
//   // ------------------------
//   const [visibleCards, setVisibleCards] = useState(6);
//   const [isLoading, setIsLoading] = useState(false);
//   const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

//   // Navigate to card details page
//   const handleCardClick = (id) => {
//     navigate(`/credit-cards/${id}`);
//   };

//   // Filter JSON cards based on toggle and bank dropdown
//   const filteredCards = creditCards
//     .filter((card) => {
//       if (filter === "recommended") return card.recommended === true;
//       if (filter === "free") return card.type === "free";
//       if (filter === "secured") return card.type === "secured";
//       if (filter === "fuel") return card.type === "fuel";
//       return true;
//     })
//     .filter((card) => {
//       if (bankFilter) {
//         const bankName = card.hero.title.split(" ")[0].toLowerCase();
//         return bankName === bankFilter.toLowerCase();
//       }
//       return true;
//     });

//   // Infinite scroll logic (only for JSON cards when no pincode result exists)
//   const loadMoreCards = useCallback(() => {
//     if (filteredCards.length > visibleCards) {
//       setIsLoading(true);
//       setTimeout(() => {
//         setVisibleCards((prev) => prev + 4);
//         setIsLoading(false);
//       }, 1000);
//     }
//   }, [filteredCards.length, visibleCards]);

//   const handleScroll = useCallback(() => {
//     if (!pincodeResult) {
//       const scrollHeight = document.documentElement.scrollHeight;
//       const scrollTop = document.documentElement.scrollTop;
//       const clientHeight = window.innerHeight;
//       if (scrollTop + clientHeight >= scrollHeight - 500 && !isLoading) {
//         loadMoreCards();
//       }
//     }
//   }, [pincodeResult, isLoading, loadMoreCards]);

//   useEffect(() => {
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [handleScroll]);

//   // ------------------------
//   // Pincode Check Function
//   // ------------------------
//   const handleCheckPincode = async () => {
//     if (!pincode.trim()) return;
//     setPincodeLoading(true);
//     setPincodeError(null);
//     setPincodeResult(null);
//     try {
//       const response = await fetch(`${BACKEND_URL}/check?pincode=${pincode}`);
//       if (!response.ok) {
//         throw new Error("Network response was not ok");
//       }
//       const data = await response.json();
//       setPincodeResult(data);
//     } catch (err) {
//       setPincodeError("Error checking pincode. Please try again.");
//     } finally {
//       setPincodeLoading(false);
//     }
//   };

//   const handleClearPincode = () => {
//     setPincode("");
//     setPincodeResult(null);
//     setPincodeError(null);
//   };


//   return (
//     <Box>
//       <Navbar />

//       <Box
//         sx={{
//           position: "relative",
//           overflow: "hidden",
//           height: { xs: "30vh", sm: "50vh", md: "60vh" }, // responsive height
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           textAlign: "center",
//           color: "#fff",
//         }}
//       >
//         {/* Background Video */}
//         <video
//           autoPlay
//           loop
//           muted
//           playsInline
//           preload="auto"
//           poster="https://ik.imagekit.io/arthgyan/Arthgyan_Web/imgproducts.mp4?updatedAt=1757133474187.jpg"
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             objectPosition: "center",
//             zIndex: 0,
//             backgroundColor: "#000",
//             filter: "brightness(0.6)",
//           }}
//         >
//           <source
//             src="https://ik.imagekit.io/arthgyan/Arthgyan_Web/imgproducts.mp4?updatedAt=1757133474187"
//             type="video/mp4"
//           />
//         </video>


//         {/* Dark Overlay for readability */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: "rgba(0,0,0,0.4)",
//             zIndex: 1,
//           }}
//         />

//         {/* Content */}
//         <Container maxWidth="md" sx={{ zIndex: 2 }}>
//           <Typography
//             variant={isSmallScreen ? "h5" : "h3"}
//             sx={{
//               fontWeight: 800,
//               color: "#fff",
//               mt: { xs: 3, sm: 5, md: 5 },
//               mb: { xs: 1, sm: 2, md: 2 },
//               textShadow: "2px 2px 6px rgba(0,0,0,0.6)",
//               fontSize: { xs: "15px", sm: "20px", md: "40px" },

//             }}
//             data-aos="zoom-in"
//           >
//             Banking Products
//           </Typography>

//           <Typography
//             sx={{
//               color: "#fff",
//               textShadow: "1px 1px 4px rgba(0,0,0,0.6)",
//               mt: 2,
//               px: { xs: 2, sm: 0 },
//               fontSize: { xs: "10px", sm: "16px", md: "18px" },
//             }}
//           >
//             Explore a wide range of credit cards, savings options, and banking solutions tailored for you.
//           </Typography>

//         </Container>
//       </Box>











//       {/* Pincode Check Section */}
//       {/* <Box
//         sx={{
//           margin: 3,
//           padding: 2,
//           border: "1px solid #ccc",
//           borderRadius: "8px",
//           backgroundColor: "#fff",
//         }}
//       >
//         <Typography variant="h6" gutterBottom>
//           Check Available Credit Cards by Pincode
//         </Typography>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}>
//           <TextField
//             label="Enter Pincode"
//             variant="outlined"
//             value={pincode}
//             onChange={(e) => setPincode(e.target.value)}
//             size="small"
//           />
//           <Button variant="contained" onClick={handleCheckPincode}>
//             Check
//           </Button>
//           {pincodeResult && (
//             <Button variant="outlined" color="secondary" onClick={handleClearPincode}>
//               Clear Pincode
//             </Button>
//           )}
//         </Box>
//         {pincodeLoading && <CircularProgress size={24} />}
//         {pincodeError && (
//           <Typography color="error" variant="body2">
//             {pincodeError}
//           </Typography>
//         )}
//         {pincodeResult && (
//           <Box sx={{ marginTop: 2 }}>
//             <Typography variant="subtitle1">Pincode: {pincodeResult.pincode}</Typography>
//             <Typography variant="subtitle1">
//               Available Banks: {pincodeResult.availableBanks.join(", ")}
//             </Typography>
//           </Box>
//         )}
//       </Box> */}

//       {/* Show Filtering Options & JSON Cards only if no pincode result */}
//       {!pincodeResult && (
//         <Box
//           sx={{
//             width: "80%",
//             marginX: "auto",
//             padding: 3,
//             // backgroundColor: "#f5f5f5",
//             borderRadius: "16px",
//             marginBottom: "1rem",
//             boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//           }}
//         >
//           {/* Filtering Toggle Button & Bank Filter */}
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: { xs: "column", sm: "row" },
//               justifyContent: "space-between",
//               alignItems: "center",
//               marginBottom: "1.5rem",
//               flexWrap: "wrap",
//               gap: "2rem",
//             }}
//           >
//             <ToggleButtonGroup
//               value={filter}
//               exclusive
//               onChange={handleFilterChange}
//               sx={{
//                 display: "flex",
//                 flexWrap: "wrap",
//                 gap: "8px",
//                 "& .MuiToggleButton-root": {
//                   height: 40,
//                   fontSize: { xs: "0.75rem", sm: "0.875rem" },
//                   borderRadius: "8px",
//                   color: "#333",
//                   borderColor: theme.palette.primary.main,
//                   "&.Mui-selected": {
//                     backgroundColor: "#0080a7",

//                     // backgroundColor: theme.palette.primary.main,
//                     color: "#fff",
//                   },
//                   "&:hover": {
//                     backgroundColor: theme.palette.primary.dark,
//                     color: "#fff",
//                   },
//                 },
//               }}
//             >

//               <ToggleButton value="recommended" aria-label="recommended">
//                 Recommended
//               </ToggleButton>
//               <ToggleButton value="free" aria-label="free">
//                 Life Time Free
//               </ToggleButton>
//               <ToggleButton value="secured" aria-label="secured">
//                 Secured Card
//               </ToggleButton>
//               <ToggleButton value="fuel" aria-label="fuel">
//                 Fuel
//               </ToggleButton>
//             </ToggleButtonGroup>
//             <Select
//               value={bankFilter}
//               onChange={handleBankFilterChange}
//               displayEmpty
//               sx={{
//                 width: { xs: "100%", sm: 220 },
//                 borderRadius: "10px",
//                 "& fieldset": {

//                   borderColor: theme.palette.primary.main,
//                 },
//                 "&:hover fieldset": {
//                   borderColor: theme.palette.primary.dark,
//                 },
//               }}
//             >

//               <MenuItem
//                 value=""
//                 sx={{
//                   fontSize: "0.8rem",
//                   "&:hover": {
//                     backgroundColor: theme.palette.primary.main,
//                     color: "#fff",
//                   },
//                 }}
//               >

//                 All Banks
//               </MenuItem>
//               {["SBI", "HDFC", "Axis", "IndusInd", "IDFC", "HSBC", "RBL"].map((bank) => (
//                 <MenuItem
//                   key={bank}
//                   value={bank}
//                   sx={{
//                     fontSize: "0.75rem",
//                     "&:hover": {
//                       backgroundColor: theme.palette.tertiary.main,
//                       // background: "red",
//                       color: "#117aae",
//                     },
//                   }}
//                 >
//                   {bank}
//                 </MenuItem>
//               ))}
//             </Select>
//           </Box>


//           <Grid container spacing={3}>
//             {filteredCards.slice(0, visibleCards).map((card) => (
//               <Grid item xs={12} sm={6} md={6} key={card.id}>
//                 <Box
//                   onClick={() => handleCardClick(card.id)}
//                   sx={{
//                     cursor: "pointer",
//                     textAlign: "center",
//                     mb: 3,
//                   }}
//                 >
//                   {/* Only Image */}
//                   <Box
//                     component="img"
//                     src={card.card.image}
//                     alt={card.hero.title}
//                     loading="lazy"
//                     sx={{
//                       width: "100%",
//                       height: "200px",
//                       objectFit: "contain",
//                       borderRadius: "16px",
//                       mb: 1,
//                     }}
//                   />

//                   {/* Card Title */}
//                   <Typography
//                     variant="body1"
//                     sx={{
//                       fontWeight: 700,
//                       color: theme.palette.primary.main,
//                       mb: 1,
//                     }}
//                   >
//                     {card.hero.title}
//                   </Typography>


//                   {/* Benefits Text */}
//                   <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
//                     <Typography
//                       variant="body2"
//                       sx={{

//                         px: 3,
//                         py: 1,
//                         backgroundColor: "#0080a7",

//                         // backgroundColor: theme.palette.primary.main,
//                         color: "#fff",
//                         fontWeight: 600,
//                         borderRadius: "8px",
//                         textTransform: "none",
//                         "&:hover": {
//                           backgroundColor: theme.palette.primary.dark,
//                         },

//                       }}
//                     >
//                       Benefits & Eligibility
//                     </Typography>

//                   </Box>

//                 </Box>
//               </Grid>
//             ))}
//           </Grid>

//           {isLoading && filteredCards.length > visibleCards && (
//             <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 3 }}>
//               <CircularProgress color="primary" />
//             </Box>
//           )}
//         </Box>
//       )}

//       {/* If pincodeResult exists, show API response cards */}
//       {pincodeResult && (
//         <Box
//           sx={{
//             width: "90%",
//             marginX: "auto",
//             padding: 3,
//             backgroundColor: "#f5f5f5",
//             borderRadius: "16px",
//             marginBottom: "2rem",
//             boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//           }}
//         >
//           <Grid container spacing={3}>
//             {pincodeResult.availableCards.map((card) => (
//               <Grid item xs={12} sm={6} md={3} key={card.id}>
//                 <ButtonBase
//                   onClick={() => handleCardClick(card.id)}
//                   sx={{
//                     width: "100%",
//                     height: "100%",
//                     display: "flex",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <Card
//                     sx={{
//                       transition: "transform 0.2s, box-shadow 0.2s",
//                       borderRadius: "16px",
//                       boxShadow: 3,
//                       backgroundColor: "#ffffff",
//                       display: "flex",
//                       flexDirection: "column",
//                       height: "350px",
//                       "&:hover": { transform: "scale(1.05)", boxShadow: 6 },
//                     }}
//                   >
//                     <CardMedia
//                       component="img"
//                       height="200"
//                       image={card.card.image}
//                       alt={card.hero.title}
//                       loading="lazy"
//                       sx={{
//                         borderTopLeftRadius: "16px",
//                         borderTopRightRadius: "16px",
//                         objectFit: "contain",
//                         width: "100%",
//                       }}
//                     />
//                     <CardContent sx={{ flexGrow: 1 }}>
//                       <Typography variant="h6" sx={{ fontWeight: "800" }} gutterBottom>
//                         {card.hero.title}
//                       </Typography>
//                     </CardContent>
//                     <Box
//                       sx={{
//                         backgroundColor: "#1687c9",
//                         borderBottomLeftRadius: "16px",
//                         borderBottomRightRadius: "16px",
//                         padding: 2,
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                       }}
//                     >
//                       <Typography variant="body2" sx={{ fontWeight: "bold", color: "white", textAlign: "center" }}>
//                         Benefits & Eligibility
//                       </Typography>
//                     </Box>
//                   </Card>
//                 </ButtonBase>
//               </Grid>
//             ))}
//           </Grid>
//         </Box>
//       )}
//       <Footer />
//     </Box>
//   );
// };

// export default BankingProductsScreen;



import React, { useState, useEffect, useCallback } from "react";
import {
  Grid,
  Container,
  Typography,
  Box,
  Select,
  MenuItem,
  CircularProgress,
  ToggleButtonGroup,
  ToggleButton,
  useTheme,
  Button,
  Chip,
  Paper,
  Divider,
} from "@mui/material";

import {
  CreditCard,
  ArrowForward,
  AccountBalance,
  VerifiedOutlined,
  StarRounded,
  ShieldOutlined,
} from "@mui/icons-material";

import { alpha } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import creditCards from "../JSON/creditCardData.json";
import Footer from "./Footer";

import "aos/dist/aos.css";
import Aos from "aos";

const BankingProductsScreen = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  // Global theme colors
  const PRIMARY = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const PRIMARY_LIGHT = theme.palette.primary.light;

  const SECONDARY = theme.palette.secondary.main;
  const SECONDARY_LIGHT =
    theme.palette.secondary.light || "#F5F9FF";

  const TERTIARY =
    theme.palette.tertiary?.main || theme.palette.success.light;

  const TEXT_DARK = theme.palette.text.primary;
  const TEXT_MUTED = theme.palette.text.secondary;

  const BG = theme.palette.background.default;
  const PAPER_BG = theme.palette.background.paper;
  const BORDER = theme.palette.divider;

  const [filter, setFilter] = useState("recommended");
  const [bankFilter, setBankFilter] = useState("");
  const [visibleCards, setVisibleCards] = useState(6);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    Aos.init({
      duration: 700,
      once: true,
      offset: 50,
    });
  }, []);

  const handleCardClick = (id) => {
    navigate(`/credit-cards/${id}`);
  };

  const handleFilterChange = (event, newFilter) => {
    if (newFilter !== null) {
      setFilter(newFilter);
      setVisibleCards(6);
    }
  };

  const handleBankFilterChange = (event) => {
    setBankFilter(event.target.value);
    setVisibleCards(6);
  };

  const filteredCards = creditCards
    .filter((card) => {
      if (filter === "recommended") {
        return card.recommended === true;
      }

      if (filter === "free") {
        return card.type === "free";
      }

      if (filter === "secured") {
        return card.type === "secured";
      }

      if (filter === "fuel") {
        return card.type === "fuel";
      }

      return true;
    })
    .filter((card) => {
      if (!bankFilter) return true;

      const bankName = card.hero?.title
        ?.split(" ")[0]
        ?.toLowerCase();

      return bankName === bankFilter.toLowerCase();
    });

  const displayedCards = filteredCards.slice(0, visibleCards);

  const bankOptions = [
    ...new Set(
      creditCards
        .map((card) => card.hero?.title?.split(" ")[0])
        .filter(Boolean)
    ),
  ];

  const loadMoreCards = useCallback(() => {
    if (isLoading || visibleCards >= filteredCards.length) return;

    setIsLoading(true);

    setTimeout(() => {
      setVisibleCards((prev) =>
        Math.min(prev + 4, filteredCards.length)
      );
      setIsLoading(false);
    }, 500);
  }, [filteredCards.length, isLoading, visibleCards]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight;
      const scrollTop = document.documentElement.scrollTop;
      const clientHeight = window.innerHeight;

      if (scrollTop + clientHeight >= scrollHeight - 350) {
        loadMoreCards();
      }
    };

    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [loadMoreCards]);

  const filterOptions = [
    { value: "recommended", label: "Recommended" },
    { value: "free", label: "Lifetime Free" },
    { value: "secured", label: "Secured Cards" },
    { value: "fuel", label: "Fuel Cards" },
  ];

  const resetFilters = () => {
    setFilter("recommended");
    setBankFilter("");
    setVisibleCards(6);
  };

  return (
    <Box
      sx={{
        bgcolor: BG,
        color: TEXT_DARK,
        minHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {/* HERO SECTION */}
      <Box
        sx={{
          position: "relative",
          minHeight: { xs: 320, sm: 350, md: 410 },
          display: "flex",
          alignItems: "center",
          overflow: "hidden",
          background: `linear-gradient(
            115deg,
            ${SECONDARY} 0%,
            ${SECONDARY_LIGHT} 48%,
            ${alpha(PRIMARY_LIGHT, 0.24)} 100%
          )`,
          borderBottom: `1px solid ${BORDER}`,
        }}
      >
        {/* Decorative Circles */}
        <Box
          sx={{
            position: "absolute",
            width: { xs: 220, md: 380 },
            height: { xs: 220, md: 380 },
            borderRadius: "50%",
            border: `55px solid ${alpha(PRIMARY, 0.055)}`,
            right: { xs: -110, md: -70 },
            top: { xs: -80, md: -140 },
            pointerEvents: "none",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            width: 200,
            height: 200,
            borderRadius: "50%",
            bgcolor: alpha(PRIMARY, 0.045),
            bottom: -110,
            left: "38%",
            pointerEvents: "none",
          }}
        />

        <Container
          maxWidth="lg"
          sx={{
            position: "relative",
            zIndex: 1,
            py: { xs: 4, md: 5 },
          }}
        >
          <Grid container alignItems="center" spacing={3}>
            {/* Hero Content */}
            <Grid item xs={12} md={8}>


              <Box
                sx={{
                  pt: { xs: 2, md: 8 },
                  // pb: { xs: 6, md: 2 },
                  px: 2,

                }}
              >

                <Container maxWidth="md">
                  <Typography
                    sx={{
                      fontSize: { xs: "20px", sm: "28px", md: "40px" },
                      fontWeight: 600,
                      textAlign: "center",
                      lineHeight: 1.1,
                      mb: 3,
                      animation: "fadeUp 0.9s ease-out both",
                      color: theme.palette.text.primary,
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        fontWeight: 900,
                        background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        position: "relative",
                        display: "inline-block",
                        "&::after": {
                          content: '""',
                          position: "absolute",
                          bottom: "-4px",
                          left: 0,
                          width: "100%",
                          height: "2px",
                          background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                        }
                      }}
                    >
                      Banking Products
                    </Box>{" "}
                    made for you
                  </Typography>





                </Container>



              </Box>



              <Typography
                sx={{
                  // mt: 2.5,
                  color: TEXT_MUTED,
                  fontSize: { xs: 14, sm: 16 },
                  lineHeight: 1.85,
                  maxWidth: 570,
                }}
              >
                Explore credit cards and banking solutions that fit
                your lifestyle. Compare benefits and find the right
                card for your needs.
              </Typography>

              <Button
                variant="contained"
                onClick={() =>
                  document
                    .getElementById("credit-card-list")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
                endIcon={<ArrowForward />}
                sx={{
                  mt: 3,
                  px: 3,
                  py: 1.25,
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 600,
                  bgcolor: PRIMARY,
                  color: theme.palette.primary.contrastText,
                  boxShadow: `0 6px 18px ${alpha(PRIMARY, 0.2)}`,
                  transition: "all 0.25s ease",
                  "&:hover": {
                    bgcolor: PRIMARY_DARK,
                    boxShadow: `0 8px 22px ${alpha(PRIMARY, 0.26)}`,
                    transform: "translateY(-2px)",
                  },
                }}
              >
                Explore Cards
              </Button>
            </Grid>

            {/* Hero Card Illustration */}
            <Grid
              item
              xs={12}
              md={4}
              sx={{
                display: { xs: "none", md: "flex" },
              }}
            >
              <Box
                data-aos="fade-left"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  py: 2,
                }}
              >
                <Box
                  sx={{
                    width: 265,
                    height: 170,
                    borderRadius: "20px",
                    p: 3,
                    color: "#FFFFFF",
                    position: "relative",
                    overflow: "hidden",
                    background: `linear-gradient(
                      135deg,
                      ${PRIMARY} 0%,
                      ${PRIMARY_DARK} 100%
                    )`,
                    boxShadow: `0 22px 45px ${alpha(PRIMARY, 0.22)}`,
                    transform: "rotate(-6deg)",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "rotate(-2deg) translateY(-4px)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      right: -35,
                      top: -50,
                      width: 150,
                      height: 150,
                      borderRadius: "50%",
                      border: `30px solid ${alpha("#FFFFFF", 0.1)}`,
                    }}
                  />

                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{ fontSize: 13, fontWeight: 700 }}
                    >
                      ARTHGYAN
                    </Typography>

                    <CreditCard sx={{ fontSize: 32 }} />
                  </Box>

                  <Box
                    sx={{
                      width: 35,
                      height: 26,
                      borderRadius: "5px",
                      bgcolor: alpha("#FFFFFF", 0.85),
                      mt: 2,
                    }}
                  />

                  <Typography
                    sx={{
                      mt: 1.5,
                      fontSize: 17,
                      fontWeight: 700,
                      position: "relative",
                    }}
                  >
                    Smart Banking
                  </Typography>

                  <Typography
                    sx={{
                      mt: 0.5,
                      fontSize: 12,
                      opacity: 0.9,
                      position: "relative",
                    }}
                  >
                    Choose what works for you
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* TRUST / BENEFITS STRIP */}
      <Container
        maxWidth="lg"
        sx={{ mt: { xs: 3, md: 4 } }}
      >
        <Grid container spacing={2}>
          {[
            {
              icon: <CreditCard />,
              title: "Multiple Choices",
              subtitle: "Explore different cards",
            },
            {
              icon: <ShieldOutlined />,
              title: "Compare Benefits",
              subtitle: "Choose with confidence",
            },
            {
              icon: <VerifiedOutlined />,
              title: "Eligibility Details",
              subtitle: "Understand card criteria",
            },
          ].map((item, index) => (
            <Grid
              item
              xs={12}
              sm={4}
              key={item.title}
              data-aos="fade-up"
              data-aos-delay={index * 80}
            >
              <Paper
                elevation={0}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  p: 2,
                  height: "100%",
                  border: `1px solid ${BORDER}`,
                  borderRadius: "13px",
                  bgcolor: PAPER_BG,
                  transition: "all 0.25s ease",
                  "&:hover": {
                    borderColor: alpha(PRIMARY, 0.4),
                    boxShadow: `0 8px 24px ${alpha(PRIMARY, 0.07)}`,
                    transform: "translateY(-3px)",
                  },
                }}
              >
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    flexShrink: 0,
                    borderRadius: "12px",
                    bgcolor: SECONDARY,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: PRIMARY,
                  }}
                >
                  {item.icon}
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 700,
                      color: TEXT_DARK,
                    }}
                  >
                    {item.title}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 12,
                      color: TEXT_MUTED,
                      mt: 0.3,
                    }}
                  >
                    {item.subtitle}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>





      {/* CREDIT CARD LISTING */}
      <Container
        maxWidth="lg"
        id="credit-card-list"
        sx={{
          py: { xs: 4, md: 6 },
          scrollMarginTop: "30px",
        }}
      >
        {/* Section Heading */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            justifyContent: "space-between",
            gap: 2,
            mb: 3,
          }}
        >
          <Box>
            <Typography
              component="h2"
              sx={{
                fontSize: { xs: "20px", sm: "28px", md: "40px" },
                fontWeight: 600,
                textAlign: "center",
                lineHeight: 1.1,
                mb: 3,
                animation: "fadeUp 0.9s ease-out both",
                color: theme.palette.text.primary,
                position: "relative",
                display: "inline-block",
                width: "100%",
              }}
            >
              Find your{" "}
              <Box
                component="span"
                sx={{
                  fontWeight: 900,
                  background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  position: "relative",
                  display: "inline-block",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: "-4px",
                    left: 0,
                    width: "100%",
                    height: "2px",
                    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                  }
                }}
              >
                Credit Card
              </Box>
            </Typography>

            <Typography
              sx={{
                mt: 1.5,
                fontSize: 14,
                lineHeight: 1.7,
                color: TEXT_MUTED,
              }}
            >
              Compare options and explore the benefits that suit you.
            </Typography>
          </Box>

          <Chip
            icon={<StarRounded />}
            label={`${filteredCards.length} Cards Available`}
            sx={{
              bgcolor: SECONDARY,
              color: PRIMARY,
              fontWeight: 700,
              border: `1px solid ${alpha(PRIMARY, 0.12)}`,
              borderRadius: "8px",
              "& .MuiChip-icon": {
                color: PRIMARY,
              },
            }}
          />
        </Box>

        {/* FILTERS */}
        <Paper
          elevation={0}
          sx={{
            p: { xs: 1.5, sm: 2 },
            mb: 3.5,
            border: `1px solid ${BORDER}`,
            borderRadius: "15px",
            bgcolor: PAPER_BG,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: { xs: "stretch", md: "center" },
              justifyContent: "space-between",
              flexDirection: { xs: "column", md: "row" },
              gap: 2,
            }}
          >
            <ToggleButtonGroup
              value={filter}
              exclusive
              onChange={handleFilterChange}
              aria-label="Filter credit cards"
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,

                "& .MuiToggleButtonGroup-grouped": {
                  border: `1px solid ${BORDER} !important`,
                  borderRadius: "9px !important",
                  margin: "0 !important",
                },

                "& .MuiToggleButton-root": {
                  px: { xs: 1.25, sm: 1.8 },
                  py: 1,
                  fontSize: { xs: 11, sm: 12.5 },
                  fontWeight: 600,
                  color: TEXT_MUTED,
                  textTransform: "none",
                  whiteSpace: "nowrap",
                  borderRadius: "9px",
                  transition: "all 0.2s ease",

                  "&.Mui-selected": {
                    bgcolor: PRIMARY,
                    color: theme.palette.primary.contrastText,
                    borderColor: PRIMARY,

                    "&:hover": {
                      bgcolor: PRIMARY_DARK,
                    },
                  },

                  "&:hover": {
                    bgcolor: SECONDARY,
                    color: PRIMARY,
                  },
                },
              }}
            >
              {filterOptions.map((option) => (
                <ToggleButton
                  key={option.value}
                  value={option.value}
                  aria-label={option.label}
                >
                  {option.label}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>

            <Select
              value={bankFilter}
              onChange={handleBankFilterChange}
              displayEmpty
              size="small"
              inputProps={{ "aria-label": "Filter by bank" }}
              sx={{
                minWidth: { xs: "100%", md: 190 },
                bgcolor: PAPER_BG,
                color: TEXT_DARK,
                borderRadius: "9px",
                fontSize: 13,

                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: BORDER,
                },

                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: PRIMARY,
                },

                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: PRIMARY,
                },

                "& .MuiSvgIcon-root": {
                  color: PRIMARY,
                },
              }}
            >
              <MenuItem value="">All Banks</MenuItem>

              {bankOptions.map((bank) => (
                <MenuItem key={bank} value={bank}>
                  {bank}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Paper>

        {/* CREDIT CARDS GRID */}
        {displayedCards.length > 0 ? (
          <Grid container spacing={{ xs: 2, md: 3 }}>
            {displayedCards.map((card, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={card.id || `${card.hero?.title}-${index}`}
                data-aos="fade-up"
                data-aos-delay={(index % 3) * 80}
              >
                <Paper
                  onClick={() => handleCardClick(card.id)}
                  elevation={0}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(event) => {
                    if (
                      event.key === "Enter" ||
                      event.key === " "
                    ) {
                      event.preventDefault();
                      handleCardClick(card.id);
                    }
                  }}
                  sx={{
                    height: "100%",
                    minHeight: 300,
                    display: "flex",
                    flexDirection: "column",
                    cursor: "pointer",
                    overflow: "hidden",
                    border: `1px solid ${BORDER}`,
                    borderRadius: "16px",
                    bgcolor: PAPER_BG,
                    transition:
                      "transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease",

                    "&:hover": {
                      transform: "translateY(-5px)",
                      borderColor: alpha(PRIMARY, 0.45),
                      boxShadow: `0 14px 35px ${alpha(PRIMARY, 0.1)}`,
                    },

                    "&:hover .card-image": {
                      transform: "scale(1.035)",
                    },

                    "&:hover .card-arrow": {
                      bgcolor: PRIMARY,
                      color: theme.palette.primary.contrastText,
                    },

                    "&:focus-visible": {
                      outline: `2px solid ${PRIMARY}`,
                      outlineOffset: 3,
                    },
                  }}
                >
                  {/* Card Image */}
                  <Box
                    sx={{
                      position: "relative",
                      bgcolor: SECONDARY_LIGHT,
                      px: 2,
                      pt: 2,
                      pb: 1.5,
                      minHeight: 195,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderBottom: `1px solid ${BORDER}`,
                    }}
                  >
                    <Box
                      component="img"
                      className="card-image"
                      src={card.card?.image}
                      alt={card.hero?.title || "Credit card"}
                      loading="lazy"
                      sx={{
                        width: "100%",
                        height: 170,
                        objectFit: "contain",
                        transition: "transform 0.25s ease",
                      }}
                    />

                    {card.recommended === true && (
                      <Chip
                        icon={<StarRounded sx={{ fontSize: 15 }} />}
                        label="Recommended"
                        size="small"
                        sx={{
                          position: "absolute",
                          top: 12,
                          left: 12,
                          bgcolor: alpha(PRIMARY, 0.1),
                          color: PRIMARY,
                          border: `1px solid ${alpha(PRIMARY, 0.12)}`,
                          fontSize: 10,
                          fontWeight: 700,

                          "& .MuiChip-icon": {
                            color: PRIMARY,
                          },
                        }}
                      />
                    )}
                  </Box>

                  {/* Card Details */}
                  <Box
                    sx={{
                      p: 2.25,
                      display: "flex",
                      flexDirection: "column",
                      flexGrow: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 700,
                        color: TEXT_DARK,
                        lineHeight: 1.5,
                        mb: 1.5,
                      }}
                    >
                      {card.hero?.title || "Credit Card"}
                    </Typography>

                    <Divider
                      sx={{
                        borderColor: BORDER,
                        mb: 1.5,
                      }}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mt: "auto",
                        gap: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          color: TEXT_MUTED,
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                      >
                        View benefits & eligibility
                      </Typography>

                      <Box
                        className="card-arrow"
                        sx={{
                          width: 34,
                          height: 34,
                          flexShrink: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "10px",
                          bgcolor: SECONDARY,
                          color: PRIMARY,
                          transition: "all 0.2s ease",
                        }}
                      >
                        <ArrowForward sx={{ fontSize: 18 }} />
                      </Box>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        ) : (
          /* EMPTY STATE */
          <Paper
            elevation={0}
            sx={{
              py: 8,
              px: 2,
              textAlign: "center",
              bgcolor: PAPER_BG,
              border: `1px solid ${BORDER}`,
              borderRadius: "16px",
            }}
          >
            <Box
              sx={{
                width: 64,
                height: 64,
                mx: "auto",
                mb: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "18px",
                bgcolor: SECONDARY,
                color: PRIMARY,
              }}
            >
              <AccountBalance sx={{ fontSize: 34 }} />
            </Box>

            <Typography
              sx={{
                color: TEXT_DARK,
                fontWeight: 700,
                fontSize: 18,
              }}
            >
              No cards found
            </Typography>

            <Typography
              sx={{
                color: TEXT_MUTED,
                mt: 1,
                fontSize: 14,
              }}
            >
              Try another bank or category.
            </Typography>

            <Button
              variant="contained"
              onClick={resetFilters}
              sx={{
                mt: 2,
                px: 3,
                py: 1,
                bgcolor: PRIMARY,
                color: theme.palette.primary.contrastText,
                borderRadius: "9px",
                textTransform: "none",
                fontWeight: 600,
                boxShadow: "none",
                "&:hover": {
                  bgcolor: PRIMARY_DARK,
                  boxShadow: `0 6px 18px ${alpha(PRIMARY, 0.18)}`,
                },
              }}
            >
              Reset Filters
            </Button>
          </Paper>
        )}

        {/* LOADING */}
        {isLoading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1.5,
              py: 4,
            }}
          >
            <CircularProgress
              size={27}
              sx={{ color: PRIMARY }}
            />

            <Typography
              sx={{
                color: TEXT_MUTED,
                fontSize: 14,
              }}
            >
              Loading more cards...
            </Typography>
          </Box>
        )}

        {/* LOAD MORE */}
        {!isLoading &&
          displayedCards.length > 0 &&
          visibleCards < filteredCards.length && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 3.5,
              }}
            >
              <Button
                variant="outlined"
                onClick={loadMoreCards}
                endIcon={<ArrowForward />}
                sx={{
                  px: 3,
                  py: 1.1,
                  borderColor: alpha(PRIMARY, 0.4),
                  color: PRIMARY,
                  borderRadius: "9px",
                  textTransform: "none",
                  fontWeight: 600,
                  transition: "all 0.2s ease",

                  "&:hover": {
                    bgcolor: SECONDARY,
                    borderColor: PRIMARY,
                    transform: "translateY(-2px)",
                  },
                }}
              >
                Load More Cards
              </Button>
            </Box>
          )}
      </Container>

      {/* FOOTER */}
      <Footer />
    </Box>
  );
};

export default BankingProductsScreen;